var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65341 19.0752C6.48806 19.0752 4.32271 19.0752 2.22298 19.0752C1.30434 19.0752 0.582562 18.5208 0.385712 17.72C0.254479 17.2272 0.385712 16.796 0.648178 16.4264C1.10749 15.8104 1.50119 15.1944 1.96051 14.5784C2.02613 14.5168 2.09174 14.3936 2.09174 14.2704C2.09174 12.7305 2.09174 11.1905 2.09174 9.71209C2.09174 7.00172 3.86339 4.66095 6.61929 3.79856C10.1626 2.56657 14.1652 4.72255 15.0182 8.23371C15.1495 8.7265 15.1495 9.21929 15.2151 9.71209C15.2151 11.2521 15.2151 12.7305 15.2151 14.2704C15.2151 14.3936 15.2807 14.5168 15.3463 14.5784C15.74 15.1944 16.1993 15.8104 16.6586 16.3648C17.0523 16.9192 17.118 17.5352 16.7899 18.1512C16.4618 18.7672 15.8712 19.0136 15.1495 19.0136C12.9185 19.0752 10.7531 19.0752 8.65341 19.0752Z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0812 19.875C10.8187 20.799 9.70327 21.5382 8.6534 21.5382C7.53792 21.5382 6.48805 20.8606 6.22559 19.875C7.80038 19.875 9.4408 19.875 11.0812 19.875Z",
    fill: "#5A5A5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.beb5e52e8bab5e627c2880653ab2b9fa.svg";
export { ForwardRef as ReactComponent };